<template>
  <section>
    <form class="columns local-lm-filters-columns">
      <div class="column is-4">
        <b-field>
          <b-datepicker
            :placeholder="$t('Orders.datePlaceholder')"
            icon="calendar-month"
            v-model="deliveryDates[0]"
            class="local-lm-filters-datepicker"
            range
          />
        </b-field>
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-button
          class="lm-default-btn-outline-green--without-width lm-default-btn-delete"
          icon-right="close"
          size="is-small"
          @click.prevent="cleanFilters"
        />
        <b-button
          class="lm-default-btn-outline-green--without-width"
          icon-right="magnify"
          size="is-small"
          @click.prevent="submitData"
        />
      </div>
    </form>
  </section>
</template>

<script>
import { mixin } from '@/mixins'

export default {
  name: 'Filters',
  props: ['options'],
  beforeDestroy () {
    this.$eventBus.$off('sortOrders')
    this.$eventBus.$off('closeModal')
  },
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  data () {
    return {
      deliveryDates: []
    }
  },
  mounted () {
    this.$eventBus.$on('sortOrders', async (sortOption) => {
      this._getOrders(sortOption)
    })

    this.$eventBus.$on('closeModal', async () => {
      this._getOrders()
    })

    this.$eventBus.$on('onPageChange', async (page) => {
      this.$store.dispatch('filters/setPage', page)
      this._getOrders()
    })
  },
  methods: {
    async _getOrders (sort = null) {
      const filters = await this.$store.getters['filters/filtersSelected']
      if (sort) filters.sort = sort

      const payload = { filters, options: this.options || '' }
      const orders = await this.$store.dispatch('orders/getOrders', payload)
      if (!orders.level) return this.wrong(this.$t(orders.errorText))

      const lengthOrders = this.$store.getters['orders/orders']
      if (orders && lengthOrders.length === 0) {
        this.$eventBus.$emit('emptyOrders')
      }

      if (orders && lengthOrders.length) {
        this.$eventBus.$emit('orders')
      }
    },

    async submitData () {
      this.$store.dispatch('filters/resetPage')

      if (this.deliveryDates.length) {
        const flattenedArray = [].concat(...this.deliveryDates)
        const dates = {
          deliveryDateBegin: this.dateTimestamp(flattenedArray[0]),
          deliveryDateEnd: this.dateTimestamp(flattenedArray[1])
        }
        this.$store.dispatch('filters/setDeliveryDateSelected', dates)
      }

      this._getOrders()
    },
    cleanFilters () {
      this.deliveryDates = []
      this.hasOpenFilterDelivery = false
      this.hasOpenFilterOrder = false

      this.$store.dispatch('filters/flushUserFilters')
      this.$store.dispatch('orders/flush')
      this.$eventBus.$emit('cleanFilters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/Filters.vue